import React from 'react';

import { ItemsSummaryStatusText } from '../../../../../common/components/ItemsSummaryModal/ItemsSummaryStatusText';
import { useDepositResultSummary } from '../../hooks/use-deposit-result-summary.hook';
import { DepositFailureResult } from './components/DepositFailureResult/DepositFailureResult';
import { DepositSuccessResult } from './components/DepositSuccessResult/DepositSuccessResult';
import { DepositSummaryFooter } from './components/DepositSummaryFooter/DepositSummaryFooter';

export const DepositResultModalBody = () => {
  const { itemsExpired, summaryText, successItems, failureItems } = useDepositResultSummary();

  return (
    <>
      <ItemsSummaryStatusText
        summaryText={summaryText}
        successItems={successItems}
        failureItems={failureItems}
        summaryTextColor={itemsExpired ? 'red.100' : undefined}
      />
      {successItems.length > 0 && <DepositSuccessResult />}
      {failureItems.length > 0 && <DepositFailureResult />}
      <DepositSummaryFooter />
    </>
  );
};
